import React from "react";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import Button from "@mui/material/Button";
import DeleteIcon from "../../../assets/icons/delete-red.svg";
import ArchiveIcon from "../../../assets/icons/archive.svg";
import LogoutIcon from "@mui/icons-material/Logout";
import "./action-confirmation-popup.scss";

interface ActionConfirmationPopupProps {
    open: boolean;
    title?: string;
    note: string;
    icon?: string;
    onClose: () => void;
    onConfirm: () => void;
    confirmButtonText?: string;
    cancelButtonText?: string;
    variant?: "danger" | "success" | "warning";
    type?: "delete" | "archive" | "logout";
    showIcon?: boolean;
}

const ActionConfirmationPopup: React.FC<ActionConfirmationPopupProps> = ({
    open,
    title,
    note,
    icon,
    onClose,
    onConfirm,
    confirmButtonText = "Confirm",
    cancelButtonText = "Cancel",
    variant = "danger",
    type = "delete",
    showIcon = true,
}) => {
    const getIcon = () => {
        if (icon)
            return (
                <img
                    src={icon}
                    className={`action-icon ${variant === "danger" ? "danger-icon" : ""}`}
                    alt="action-icon"
                />
            );
        if (type === "logout")
            return (
                <LogoutIcon
                    className={`action-icon ${variant === "danger" ? "danger-icon" : ""}`}
                    style={{ color: "#d32f2f", fontSize: 32 }}
                />
            );
        const iconSrc = type === "archive" ? ArchiveIcon : DeleteIcon;
        return (
            <img
                src={iconSrc}
                className={`action-icon ${variant === "danger" ? "danger-icon" : ""}`}
                alt="action-icon"
            />
        );
    };

    return (
        <Dialog
            open={open}
            onClose={onClose}
            aria-labelledby="action-dialog-title"
            aria-describedby="action-dialog-description"
            className="action-confirmation-popup-wrapper"
        >
            <DialogTitle id="action-dialog-title">
                <div className="header-wrapper">
                    {showIcon && <div className="image-wrapper">{getIcon()}</div>}
                </div>
            </DialogTitle>
            <DialogContent>
                <DialogContentText id="action-dialog-description">
                    {title && <p className="title-content">{title}</p>}
                    <p className="desc-content">{note}</p>
                </DialogContentText>
            </DialogContent>
            <DialogActions>
                <Button onClick={onClose} className="cancel-btn" type="button">
                    {cancelButtonText}
                </Button>
                <Button
                    onClick={onConfirm}
                    className={`action-btn ${variant === "danger" ? "reject-btn" : "approve-btn"
                        }`}
                    autoFocus
                    type="button"
                >
                    {confirmButtonText}
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default ActionConfirmationPopup;
